module.exports = __webpack_public_path__ + "static/media/campus_7.61f8f654.png";